<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto" ref="addImage">
                    <div style="width:70%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["FR"][obj_fr.I > 0? obj_fr.RS==3?"VFR": "EFR": "AFR"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="bool_isAMV =!bool_isAMV">

                                            <CIcon name=cilX></CIcon>

                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" ref="capture">
                                    <CRow class="align-items-center">
                                        <CCol col="4" class="form-group" v-if="obj_fr['I']>0" id="swich1" style="margin-top: .76563rem">
                                            <CButton color="outline-info" size="sm" @click="GetRecord(1)">
                                                <span class='plusIcon cil-plus'></span>
                                                {{this.getLanguage["FR"]["PR"]}}
                                            </CButton>
                                        </CCol>

                                        <CCol col="4" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["FR"]["ST"]}}<span class="required" /> :</label>
                                            <vue-monthly-picker v-model="YearMonth"
                                                                :clearOption="false"
                                                                :monthLabels="arry_MonthLabels"
                                                                :disabled="obj_fr['I']>0"
                                                                dateFormat="YYYY-MMM"
                                                                selectedBackgroundColor="blue"
                                                                @selected="ChangeToMonth">
                                            </vue-monthly-picker>
                                            <span class="ErrMsg">{{ ValidationErrMsg('YearMonth','ST') }}</span>
                                        </CCol>
                                        <CCol col="4" class="form-group" v-if="obj_fr['I']>0" id="swich2" style="margin-top: .76563rem">
                                            <CButton color="outline-info" size="sm" @click="GetRecord(2)">
                                                <span class='plusIcon cil-plus'></span>
                                                {{this.getLanguage["FR"]["NR"]}}
                                            </CButton>
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol col="12">
                                            <!-- <CRow style="padding-top: 20px;padding-left: 15px;padding-right: 10px;"> -->
                                            <table class="custom-table custom-table-inPopUp2 afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th colspan="100%" id="swich3">{{this.getLanguage["FR"][obj_fr.I > 0? obj_fr.RS==3?"VFR": "EFR": "AFR"]}}</th>
                                                        <th colspan="100%" id="swich4" style="display:none">{{this.getLanguage["FR"]["FR"]}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        <td class="tableCtnRight"> {{this.getLanguage["FR"]["CDT"]}} ({{str_ISOC}})</td>
                                                        <td class="tableCtnRight"> {{this.getLanguage["FR"]["D"]}} ({{str_ISOC}})</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["PTP"]}}</td>
                                                        <td class="tableCtnRight" :style="setStyle(obj_fr.TWL)"> {{ formatNumber(obj_fr.TWL, 2, str_ISOC, false) }}</td>
                                                        <td></td>
                                                    </tr>

                                                    <tr><td colspan="100%"></td></tr>
                                                    <tr><td colspan="100%"><u>{{this.getLanguage["FR"]["S"]}}</u></td></tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["MMF"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CA1, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['MMF']" class="cInputRight" v-model="obj_fr['CA1']" onchange="document.getElementById('CA1').innerHTML = this.value;" />
                                                            <div id="CA1" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CA1?obj_fr.CA1:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["MIS"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CA2, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['MIS']" class="cInputRight" v-model="obj_fr['CA2']" onchange="document.getElementById('CA2').innerHTML = this.value;" />
                                                            <div id="CA2" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CA2?obj_fr.CA2:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr><td colspan="100%"></td></tr>
                                                    <tr><td colspan="100%"><u>{{this.getLanguage["FR"]["ME"]}}</u></td></tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["TBC"]}}</td>
                                                        <td></td>
                                                        <td class="tableCtnRight"> {{ formatNumber(obj_fr.BGT, 2, str_ISOC, false) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["TBF"]}}</td>
                                                        <td class="tableCtnRight"> {{ formatNumber(obj_fr.BF, 2, str_ISOC, false) }} </td>
                                                        <td></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["TAP"]}}</td>
                                                        <td></td>
                                                        <td class="tableCtnRight"> {{ formatNumber(obj_fr.CB1, 2, str_ISOC, false) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["ARB"]}}</td>
                                                        <td></td>
                                                        <td class="tableCtnRight"> {{ formatNumber(obj_fr.CB3, 2, str_ISOC, false) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["MEM"]["REWARD"]}}</td>
                                                        <td></td>
                                                        <td class="tableCtnRight"> {{ formatNumber(obj_fr.CB4, 2, str_ISOC, false) }}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td>{{this.getLanguage["FR"]["TAP"]}} </td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight">{{str_ISOC}} {{ formatNumber(obj_fr.CB1, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['TAP']" class="cInputRight" v-model="obj_fr['CB1']" onchange="document.getElementById('CB1').innerHTML = this.value;" />
                                                            <div id="CB1" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CB1, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr> -->

                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["AC"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CB2, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['AC']" class="cInputRight" v-model="obj_fr['CB2']" onchange="document.getElementById('CB2').innerHTML = this.value;" />
                                                            <div id="CB2" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CB2?obj_fr.CB2:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr><td colspan="100%"></td></tr>
                                                    <tr><td colspan="100%"><u>{{this.getLanguage["FR"]["OE"]}}</u></td></tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["CSOC"]}} </td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CC1, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['CSOC']" class="cInputRight" v-model="obj_fr['CC1']" onchange="document.getElementById('CC1').innerHTML = this.value;" />
                                                            <div id="CC1" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CC1?obj_fr.CC1:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["MOC"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CC2, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['MOC']" class="cInputRight" v-model="obj_fr['CC2']" onchange="document.getElementById('CC2').innerHTML = this.value;" />
                                                            <div id="CC2" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CC2?obj_fr.CC2:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["H2P"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight">{{ formatNumber(obj_fr.CC3, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['H2P']" class="cInputRight" v-model="obj_fr['CC3']" onchange="document.getElementById('CC3').innerHTML = this.value;" />
                                                            <div id="CC3" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CC3?obj_fr.CC3:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["BR"]}}</td>
                                                        <td></td>
                                                        <td v-if="obj_fr.RS == 3" class="tableCtnRight"> {{ formatNumber(obj_fr.CC4, 2, str_ISOC, false) }}</td>
                                                        <td v-else>
                                                            <CInput size="sm" :placeholder="getLanguage['FR']['BR']" class="cInputRight" v-model="obj_fr['CC4']" onchange="document.getElementById('CC4').innerHTML = this.value;" />
                                                            <div id="CC4" class="tableCtnRight" style="display:none">{{ formatNumber(obj_fr.CC4?obj_fr.CC4:0, 2, str_ISOC, false) }}</div>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td></td>
                                                        <td class="tableCtnRight">{{ formatNumber((obj_fr.TWL+obj_fr.BF), 2, str_ISOC, false) }}</td>
                                                        <td class="tableCtnRight">{{ string_net }}</td>
                                                    </tr>
                                                    <tr v-if="obj_fr.I >0 &&obj_fr.RS !=3">
                                                        <td v-if="obj_fr.RS !=3">{{this.getLanguage["FR"]["LU"]}} ({{ formatDateTime(obj_fr.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }})</td>

                                                        <!-- <td v-else>{{this.getLanguage["FR"]["TPL"]}}</td> -->
                                                        <td class="tableCtnRight" :style="setStyle(obj_fr.TPL)"> {{ formatNumber(obj_fr.TPL, 2, str_ISOC, false)}}</td>
                                                        <td></td>
                                                    </tr>
                                                    <!-- <tr v-if="obj_fr.RS !=3">
                                                        <td>{{this.getLanguage["FR"]["TPL"]}}</td>
                                                        <td class="tableCtnRight" :style="setStyle(decimal_newNet)">{{str_ISOC}} {{ formatNumber(decimal_newNet, 2, str_ISOC, false) }}</td>
                                                        <td></td>
                                                    </tr> -->

                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td>{{this.getLanguage["FR"]["TPL"]}}</td>
                                                        <td colspan="2" class="text-right" :style="setStyle(decimal_newNet)" style="font-size:20px">{{  formatNumber(decimal_newNet, 2, str_ISOC) }}</td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            <!-- </CRow> -->
                                        </CCol>
                                    </CRow>
                                </div>

                                <div style="text-align:center;margin-top:20px" v-if="obj_fr.RS==3">
                                    <CButton color="outline-dark" size="sm" @click="generatorPDF()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["FR"]["VPDF"]}}
                                    </CButton>
                                    <CButton color="outline-warning" size="sm" @click="saveToExcel(obj_fr.I)">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["FR"]["STE"]}}
                                    </CButton>
                                    <CButton color="outline-primary" size="sm" @click="bool_isAMV =!bool_isAMV">
                                        <CIcon name=cilX></CIcon>
                                        {{this.getLanguage["BTN"]["CLO"]}}
                                    </CButton>
                                </div>

                                <div style="text-align:center;margin-top:20px" v-else>
                                    <CButton color="outline-dark" size="sm" @click="generatorPDF()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["GL"]["P"]}}
                                    </CButton>
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                    <CButton color="outline-primary" size="sm" @click="SignOff()">
                                        <span class='plusIcon cil-lock-locked'></span>
                                        {{this.getLanguage["FR"]["SOFF"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader'>
                        <h2 id="titleHeight">{{checkModuleIndex('FR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["FR"]["FR"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addBank()"> <span class='plusIcon cil-plus'></span> {{getLanguage["BTN"]["AN"]}}</CButton>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{this.getLanguage["FR"]["FRL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue' id="tblData">
                        <thead>
                            <tr>
                                <th>{{getLanguage[["GL"]]["NO"]}}</th>
                                <th class="tableCtnCenter">{{getLanguage["GL"]["ACT"]}}</th>
                                <th class="tableCtnCenter">{{this.getLanguage["FR"]["YM"]}}<i @click="setSortTable('Y')" :class="setSortLogo('Y')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage["FR"]["C"]}}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{this.getLanguage["FR"]["TWL"]}}<i @click="setSortTable('TWL')" :class="setSortLogo('TWL')" class="sortlogo"></i> </th>
                                <th class="tableCtnRight">{{this.getLanguage["FR"]["TE"]}} <i @click="setSortTable('TE')" :class="setSortLogo('TE')" class="sortlogo"></i></th>
                                <th class="tableCtnRight"> {{this.getLanguage["FR"]["N"]}} <i @click="setSortTable('N')" :class="setSortLogo('N')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_bl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_bl" v-bind:key="index">
                            <td>{{ CountItem(index+1)}}</td>
                            <td>
                                <span id="actionBtnCol">
                                    <div v-if="data.RS == 3" class="custom_tooltip">
                                        <i class="cil-description" @click='editBank(data.I)'></i> <!--here Edit -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                    </div>
                                    <div v- class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit)  && data.RS != 3">
                                        <i class="cil-color-border" @click='editBank(data.I)'></i> <!--here Edit -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.delete)&& data.RS != 3" class="custom_tooltip">
                                        <i class="cil-trash" @click="removeFN(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td class="tableCtnCenter"> {{ formatDate(data.Y,data.M)  }}</td>
                            <td>{{data.ISOC}}</td>
                            <td class="tableCtnRight" style="data.TWL > 0 ? 'color : green' : 'color : red'">{{ formatNumber(data.TWL, 2, str_ISOC) }}</td>
                            <td class="tableCtnRight">
                                <div class="custom_tooltip">
                                    <span>-{{ formatNumber(data.TE, 2, str_ISOC) }}</span>
                                    <span class="tooltiptext">{{getLanguage["FR"]["TME"]}} :{{ formatNumber(data.TME, 2, str_ISOC) }} <br> {{getLanguage["FR"]["TSE"]}} :{{ formatNumber(data.TSE, 2, str_ISOC) }} <br> {{getLanguage["FR"]["TOE"]}} :{{ formatNumber(data.TOE, 2, str_ISOC) }} </span>
                                </div>
                            </td>
                            <td class="tableCtnRight" style="data.TPL > 0 ? 'color : green' : 'color : red'">{{ formatNumber(data.TPL, 2, str_ISOC) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Treeselect from '@riophae/vue-treeselect'
    import DateRangePicker from 'vue2-daterange-picker'
    import VueMonthlyPicker from 'vue-monthly-picker'
    //you need to import the CSS manually (in case you want to override it)
    import Loading from 'vue-loading-overlay';
    import moment from 'moment'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue';
    import { required, minLength, between, url, decimal } from 'vuelidate/lib/validators';
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import genericHelper from "@/modules/GenericHelper.js";
    import html2canvas from 'html2canvas';
    import JsPDF from 'jspdf';

    Vue.use(require('vue-moment'));
    export default {
        mixins: [genericHelper],
        components: {
            VueMonthlyPicker,
            DateRangePicker,
            Treeselect,
            Loading,
            html2canvas,
            JsPDF
        },
        props: {

        },
        data()
        {
            return {
                bool_isAMV: false, // Add Modal Visible
                int_lblPage: 1,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                timeout: [],
                //the parameter of getList()
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "Y", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                //array hold data
                str_ISOC: "",
                arry_MonthLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                int_CurrencyId: 0,
                YearMonth: null,
                newImg: false,
                isEdit: true,
                string_net: "0",
                decimal_newNet: 0,
                selectedFile: null,
                dd_agentgroup2: [],
                bool_CV: false, // Check Validation
                arry_bl: [], //Bank List
                obj_fr: [], //Add Bank
                constAccessType: constAccessType,
                DateTime: this.getTodayDate(),
                hideBrand: false,
            }
        },
        validations: {
            YearMonth: { required },
            obj_fr: {


                CA1: { decimal },
                CA2: { decimal },
                CB1: { decimal },
                CB2: { decimal },
                CC1: { decimal },
                CC2: { decimal },
                CC3: { decimal },
                CC4: { decimal },

            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),

            CheckMultiple()
            {
                // return `${this.obj_fr.SR}|${this.obj_fr.RT}|${this.obj_fr.MK}|${this.obj_fr.OTH}|${this.obj_fr.TWL}`;
                return `${this.obj_fr.TWL}|${this.obj_fr.BF}|${this.obj_fr.BGT}|${this.obj_fr.CA1}|${this.obj_fr.CA2}|${this.obj_fr.CB1}|${this.obj_fr.CB2}|${this.obj_fr.CC1}|${this.obj_fr.CC2}|${this.obj_fr.CC3}|${this.obj_fr.CC4}`;
            },
        },
        methods: {
            generatorPDF()
            {
                if (this.$refs.capture.getElementsByTagName("INPUT").length > 0)
                {
                    for (var i = 0; i < this.$refs.capture.getElementsByTagName("INPUT").length; i++)
                    {
                        this.$refs.capture.getElementsByTagName("INPUT")[i].style.display = "none";
                    }
                    this.$refs.capture.querySelectorAll('#CA1')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CA2')[0].style.display = null;
                    //this.$refs.capture.querySelectorAll('#CB1')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CB2')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CC1')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CC2')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CC3')[0].style.display = null;
                    this.$refs.capture.querySelectorAll('#CC4')[0].style.display = null;
                }
                if(this.obj_fr.I >0){
                    this.$refs.capture.querySelectorAll('#swich1')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#swich2')[0].style.display = "none";
                }
                this.$refs.capture.querySelectorAll('#swich3')[0].style.display = "none";
                this.$refs.capture.querySelectorAll('#swich4')[0].style.display = null;
                

                this.$refs.capture.style.maxHeight = 'none';
                html2canvas(this.$refs.capture, {
                    useCORS: true,
                    allowTaint: true
                }).then(canvas =>
                {
                    let contentWidth = canvas.width;
                    let contentHeight = canvas.height;
                    let pageHeight = (contentWidth / 592.28) * 841.89;
                    let leftHeight = contentHeight;
                    let position = 0;
                    const imgWidth = 595.28;
                    let imgHeight = (592.28 / contentWidth) * contentHeight;
                    let pageData = canvas.toDataURL('image/jpeg', 1.0);
                    let PDF = new JsPDF('', 'pt', 'a4');
                    if (leftHeight < pageHeight)
                    {
                        PDF.addImage(pageData, 'JPEG', 0, 10, imgWidth, imgHeight);
                    }
                    else
                    {
                        while (leftHeight > 0)
                        {
                            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                            leftHeight -= pageHeight;
                            position -= 841.89;
                            if (leftHeight > 0)
                            {
                                PDF.addPage();
                            }
                        }
                    }
                    
                    var date1 = new Date();
                    var str_date = moment().format('DD MMM YYYY h:mm:ss a');
                    PDF.setFontSize(10)
                    PDF.text(450,800, str_date);
                    PDF.output('dataurlnewwindow');
                    //PDF.save('Preview.pdf');
                    //window.open(pdf.output('bloburl', { filename: 'Preview.pdf' }), '_blank');
                })
                if (this.$refs.capture.getElementsByTagName("INPUT").length > 0)
                {
                    for (var i = 0; i < this.$refs.capture.getElementsByTagName("INPUT").length; i++)
                    {
                        this.$refs.capture.getElementsByTagName("INPUT")[i].style.display = null;
                    }
                    this.$refs.capture.querySelectorAll('#CA1')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CA2')[0].style.display = "none";
                    //this.$refs.capture.querySelectorAll('#CB1')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CB2')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CC1')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CC2')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CC3')[0].style.display = "none";
                    this.$refs.capture.querySelectorAll('#CC4')[0].style.display = "none";
                }
                if(this.obj_fr.I >0){
                    this.$refs.capture.querySelectorAll('#swich1')[0].style.display = null;
                this.$refs.capture.querySelectorAll('#swich2')[0].style.display = null;
                }
                this.$refs.capture.querySelectorAll('#swich3')[0].style.display = null;
                this.$refs.capture.querySelectorAll('#swich4')[0].style.display = "none";
                
                this.$refs.capture.style.maxHeight = null;
            },
            getDate()
            {
                var self = this;
                self.DateTime = new Date();
                self.timeout[0] = setTimeout(() =>
                {
                    self.getDate();
                }, 1000);
            },
            checkModuleAccess2(type)
            {
                return this.checkModuleAccess('FR', 'R', type);
            },
            checkStatus(RS)
            {
                var a = this.$parent.checkStatus(RS);
            },
            ctrPage(newPage,inputValue = 1)
            {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getFinanceList();
            },
            CountItem(value)
            {
                if (this.int_IC != 1)
                {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else
                {
                    return value;
                }
            },
            AgentGroupChange(value)
            {
                var that = this;
                var agi = 0;

                if (value != "")
                {
                    agi = value.split("-")[1];
                }
            },

            ChangeToMonth()
            {
                this.bool_fullLoading = true;
                var x = this.YearMonth._d;
                if (x.getTime() > new Date().getTime())
                {
                    this.$fire({
                        title: this.getLanguage["FR"]["DOR"],//"Data Out of Range" ,//this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    });
                    this.YearMonth = moment(new Date(new Date().getFullYear(), new Date().getMonth()));
                    this.bool_fullLoading = false;
                }
                else
                {
                    var date_start = new Date(x.getFullYear(), x.getMonth(), 1);
                    var str_start = this.parseDateToJsonString(date_start);
                    var date_end = new Date(x.getFullYear(), x.getMonth() + 1, 0, 23, 59, 59, 59);
                    var str_end = this.parseDateToJsonString(date_end);

                    var param = {
                        "f": {
                            "CI": this.int_CurrencyId,
                            "STS_from": str_start,
                            "STS_to": str_end,
                            "AGT": this.getUserInfo.AT
                        }
                    }
                    var that = this;
                    
                    //this.getDataApi(`/api/reports/winloss/totalf?f.CI=${that.int_CurrencyId}&f.STS_from=${str_start}&f.STS_to=${str_end}&f.AGT=${that.getUserInfo.AT}`,
                    this.postDataApi(`/api/reports/winloss/total`, param,
                        function (d, s)
                        {
                            if (s)
                            {
                                if (d.R2)
                                {
                                    if (d.R2[0].WWL == null)
                                    {
                                        that.obj_fr.TWL = 0;
                                    } else
                                    {
                                        that.obj_fr.TWL = d.R2[0].WWL;
                                    }

                                }

                            }
                        });

                    this.getDataApi(`/api/mpromo/lr/total?f.CI=${that.int_CurrencyId}&f.PTS_from=${str_start}&f.PTS_to=${str_end}`,
                        function (data)
                        {
                            that.bool_fullLoading = false;
                            that.setPromotionSummaryList(data);
                        });

                    this.getDataApi(`/api/dc/boc?f[CTS_from]=${str_start}&f[CTS_to]=${str_end}&f[C_date]=${str_end}&f[TT]=2&f[CTCI]=${that.int_CurrencyId}`,
                    function (d, s) {
                        if (s) {
                            that.obj_fr.BGT = 0;
                            that.obj_fr.CB1 = 0;
                            that.obj_fr.CB4 = 0;
                            that.obj_fr.CB3 = 0;
                            if (d != null) {
                                var SummaryArray = d;
                                
                                var testdata = 0;
                                var arrl = parseInt(SummaryArray.length);
                                var i = 0;
                                for (i = 0; i < arrl; i++) {
                                    if (SummaryArray[i].TT == 1) {
                                        that.obj_fr.BGT += SummaryArray[i].TBA;
                                        testdata += SummaryArray[i].TBA;
                                    }
                                    else
                                        if (SummaryArray[i].TT == 2) {
                                            that.obj_fr.CB3 += SummaryArray[i].TBA;//cb3=CostB3rebeat
                                        }
                                        else if (SummaryArray[i].TT == 3) {
                                            that.obj_fr.CB4 += SummaryArray[i].TBA;//cb4=CostB4dls
                                        }
                                        else if (SummaryArray[i].TT == 4) {
                                            that.obj_fr.CB1 += SummaryArray[i].TBA;//cb1=CostB1aff
                                        }
                                }
                            }
                        }
                    });

                    this.obj_fr.Y = x.getFullYear();
                    this.obj_fr.M = x.getMonth() + 1;
                    

                }

            },
            setPromotionSummaryList(data)
            {
                var arry_Psl = data;
                //this.obj_fr.BGT = 0;
                this.obj_fr.BF = 0;
                var testdata=0;
                if (arry_Psl.length != 0)
                {
                    for (var i = 0; i < data.length; i++)
                    {
                        //this.obj_fr.BGT += data[i].GT;
                        testdata += data[i].GT;
                        this.obj_fr.BF += data[i].GTF;
                    }
                }
            },
            formatDate(a, b)
            {
                return moment(new Date(a, b - 1)).format("YYYY - MMM")
            },
            getFinanceList()
            {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                this.getDataApi(`/api/fr/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setFinanceList(d.D);
                        }
                    });
            },
            setFinanceList(data)
            {   // this out put at Bank.js and this output after get list
                var bl = data.Items;

                this.arry_bl = bl;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            removeFN(data) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: data.I,
                            uts: data.UTS
                        };

                        this.postDataApi(`/api/FR/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getFinanceList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            getDropdownList()
            {
                var that = this;
                this.getDataApi(`/api/ag/gcag`,
                    function (d, s)
                    {
                        if (s)
                        {
                            that.str_ISOC = d.D.ISOC;
                            that.int_CurrencyId = d.D.CI;
                        }
                    });
            },
            SignOff()
            {
                this.$v.obj_fr.$touch();
                this.$v.YearMonth.$touch();
                if (!this.$v.obj_fr.$error && !this.$v.YearMonth.$error)
                {
                    this.$fire({
                        title: this.getLanguage["FR"]["SOFF"],//"Sign Off",
                        width: '30em',
                        showCancelButton: true,
                        html: this.getLanguage["FR"]["SFMG"],//"Report cannot be modified after signed off. Please make sure all the amount is finalized before sign off. Are you confirm to sign off this report?",
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) =>
                    {
                        if (result.value == true)
                        {
                            this.obj_fr.RS = 3;
                            this.saveBank();
                        }
                    });

                }
            },
            saveBank()
            {
                this.bool_CV = true;
                this.$v.obj_fr.$touch();
                this.$v.YearMonth.$touch();
                if (!this.$v.obj_fr.$error && !this.$v.YearMonth.$error)
                {
                    this.obj_fr.TPL = this.decimal_newNet;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;
                    var that = this;

                    //if user edit, but want to retain image
                    this.postDataApi(`/api/fr/s`, this.obj_fr,
                        function (d, s)
                        {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s)
                            {
                                that.bool_isAMV = false;
                                that.getFinanceList();
                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                            }
                        });

                }
            },
            GetRecord(action){
                this.bool_fullLoading = true;
                this.isEdit = true;
                this.bool_CV = false;
                var that = this;
                var obj=this.obj_fr;
                this.getDataApi(`/api/fr/gre/${obj.Y}/${obj.M}/${action}`,
                    function (d, s)
                    {
                        that.bool_fullLoading = false;
                        if (s)
                        {
                            that.obj_fr = d.D;

                            that.YearMonth = moment(new Date(d.D.Y, d.D.M - 1)),
                                that.bool_isAMV = true;

                        }
                    });

            },
            editBank(id)
            {
                this.bool_fullLoading = true;
                this.isEdit = true;
                this.bool_CV = false;
                var that = this;
                this.getDataApi(`/api/fr/g/${id}`,
                    function (d, s)
                    {
                        that.bool_fullLoading = false;
                        if (s)
                        {
                            that.obj_fr = d.D;

                            that.YearMonth = moment(new Date(d.D.Y, d.D.M - 1)),
                                that.bool_isAMV = true;

                        }
                    });

            },
            saveToExcel(id)
            {
                window.open('/api/fr/ge/' + id, '_blank');
            },

            ValidationErrMsg(value, langKey = "")
            {

                if (this.bool_CV)
                {
                    if (value = 'YearMonth')
                    {
                        var validateObj = this.$v.YearMonth
                        if (validateObj.required != undefined && !validateObj.required)
                        {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["FR"][langKey]);
                        }

                    } else
                    {
                        var validateObj = this.$v.obj_fr[value];

                        if (validateObj.required != undefined && !validateObj.required)
                        {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["FR"][langKey]);
                        }
                        else if (validateObj.decimal != undefined && !validateObj.decimal)
                        {
                            return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["FR"][langKey]);
                        }

                    }

                }

            },
            addBank()
            {
                this.obj_fr = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    CI: this.int_CurrencyId,
                    TWL: 0.00,
                    BGT: 0.00,
                    BF: 0.00,
                    Y: 0,
                    M: 0,
                    CA1: null,
                    CA2: null,
                    CB1: null,
                    CB2: null,
                    CB3: null,
                    CB4: null,
                    CC1: null,
                    CC2: null,
                    CC3: null,
                    CC4: null,
                    TPL: 0,

                };
                this.YearMonth = moment(new Date(new Date().getFullYear(), new Date().getMonth()));
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.isEdit = false;
                this.ChangeToMonth();
            },


            setSortTable(SV)
            { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
            },
            setSortLogo(str_TF)
            {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            checkDecimalNull(v)
            {
                if (v == null || v == "")
                {
                    return 0;
                } else
                {
                    return parseFloat(v);
                }
            },
            setStyle(value)
            {
                if (value > 0)
                {
                    return { color: "green" };
                } else if (value < 0)
                {
                    return { color: "red" };
                }
            }

        },
        watch: {
            bool_isSort(newValue)
            {
                this.getFinanceList();
            },
            CheckMultiple()
            {
                this.decimal_newNet = this.obj_fr.TWL + this.obj_fr.BF - this.obj_fr.BGT - this.obj_fr.CA1 - this.obj_fr.CA2 - this.obj_fr.CB1 - this.obj_fr.CB2- this.obj_fr.CB3- this.obj_fr.CB4 - this.obj_fr.CC1 - this.obj_fr.CC2 - this.obj_fr.CC3 - this.obj_fr.CC4;

                var aa = this.checkDecimalNull(this.obj_fr.BGT) + this.checkDecimalNull(this.obj_fr.CA1) + this.checkDecimalNull(this.obj_fr.CA2) + this.checkDecimalNull(this.obj_fr.CB1) + this.checkDecimalNull(this.obj_fr.CB2)+ this.checkDecimalNull(this.obj_fr.CB3)+ this.checkDecimalNull(this.obj_fr.CB4) + this.checkDecimalNull(this.obj_fr.CC1) + this.checkDecimalNull(this.obj_fr.CC2) + this.checkDecimalNull(this.obj_fr.CC3) + this.checkDecimalNull(this.obj_fr.CC4);

                this.string_net = this.formatNumber(aa, this.str_ISOC);
            },
        },
        beforeRouteLeave (to, from, next) {
            clearTimeout(this.timeout[0]);
            next();
        },
        created()
        {
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.FR';
            if (this.checkModuleIndex('FR', 'R', constAccessType.view, '', -1) == '7.2.4') {
                this.$parent.showSubSubMenu = 'RS2';
            } else if (this.checkModuleIndex('FR', 'R', constAccessType.view, '', -1) == '7.5.2') {
                this.$parent.showSubSubMenu = 'RS5';
            }

            this.hideBrand = this.getUserInfo.IHAGIF;

            this.getDropdownList();
            this.getFinanceList();
        },
        mounted()
        {
           // this.getDate();
        }
    }

</script>
<style>
    .textCenter {
        margin-top: 2em;
    }

        .textCenter h6 {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #000;
            line-height: 0.1em;
            margin: 10px 0 20px;
        }

    .cInputRight input {
        text-align: right;
    }

    .textCenter h6 span {
        background: #fff;
        padding: 0 10px;
    }

    /*.modal-main-content {
        overflow-x: auto;
        overflow-y: auto;
        padding: 15px;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/FinanceReport.vue